import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  t: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const WunderflatsStats = (props) => {
  const { className, t } = props;

  return (
    <div className={`WunderflatsStats${className ? ` ${className}` : ""}`}>
      <article className="WunderflatsStats-wrapper">
        <h3 className="heading-large heading-large--light heading-large--bold">
          {t("components.WunderflatsStats.title")}
        </h3>
      </article>
    </div>
  );
};

WunderflatsStats.propTypes = propTypes;
export default WunderflatsStats;
